let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hUyrS")).then(() => parcelRequire('2HTK7'));